"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTitle = exports.createBreadcrumbs = exports.createRoutes = exports.generateLinkByPattern = void 0;
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const generateLinkByPattern = (patternPath = '', path = '') => {
    var _a;
    const parentPath = ((_a = (0, react_router_1.matchPath)({
        path: patternPath,
        end: false,
    }, window.location.pathname)) === null || _a === void 0 ? void 0 : _a.pathname) || '';
    if (path.startsWith('/') || !parentPath)
        return path;
    return `${parentPath}`;
};
exports.generateLinkByPattern = generateLinkByPattern;
function createRoutes(routerSchema) {
    return (routerSchema.map((route) => {
        var _a;
        return ({
            breadcrumb: route.breadcrumb,
            path: route.url,
            element: (react_1.default.createElement(react_1.Suspense, { fallback: (_a = route === null || route === void 0 ? void 0 : route.fallback) !== null && _a !== void 0 ? _a : null },
                react_1.default.createElement(route.Component, Object.assign({}, route.props)))),
            children: route.children ? createRoutes(route.children) : [],
        });
    }));
}
exports.createRoutes = createRoutes;
const findMatchRoutes = (locationPathName = '', routes = []) => {
    const matchedRoutes = (0, react_router_1.matchRoutes)(routes, locationPathName) || [];
    const paths = locationPathName.split('/').filter((path, index) => !!path || index === 0);
    let rootPath = '';
    return paths
        .map((path) => {
        var _a;
        rootPath += `${path}/`;
        const sanitizedPath = rootPath.endsWith('/') && rootPath !== '/' ? rootPath.substring(0, rootPath.length - 1) : rootPath;
        const matchedRoute = matchedRoutes.find(({ pathnameBase = '' }) => pathnameBase.endsWith(sanitizedPath));
        if (matchedRoute)
            return matchedRoute;
        return (_a = (0, react_router_1.matchRoutes)(routes, sanitizedPath)) === null || _a === void 0 ? void 0 : _a.find(({ pathname, route }) => {
            var _a;
            return (pathname === sanitizedPath || (0, react_router_1.matchPath)({ path: (_a = route.path) !== null && _a !== void 0 ? _a : '', end: true }, sanitizedPath));
        });
    })
        .filter(({ route }) => route.path !== '*');
};
const createBreadcrumbs = (routerSchema, location) => {
    const routes = findMatchRoutes(location.pathname, createRoutes(routerSchema));
    return routes
        .filter((match) => { var _a; return !!((_a = match === null || match === void 0 ? void 0 : match.route) === null || _a === void 0 ? void 0 : _a.breadcrumb); })
        .map((match) => {
        var _a, _b, _c;
        return ({
            params: match.params,
            pathname: match.pathnameBase,
            breadcrumb: (typeof ((_a = match === null || match === void 0 ? void 0 : match.route) === null || _a === void 0 ? void 0 : _a.breadcrumb) === 'function' ? (_b = match === null || match === void 0 ? void 0 : match.route) === null || _b === void 0 ? void 0 : _b.breadcrumb(match)
                : (_c = match === null || match === void 0 ? void 0 : match.route) === null || _c === void 0 ? void 0 : _c.breadcrumb),
        });
    });
};
exports.createBreadcrumbs = createBreadcrumbs;
const getTitle = (title, t) => {
    if (typeof title === 'function')
        return title(t);
    return title || '';
};
exports.getTitle = getTitle;
//# sourceMappingURL=utils.js.map